import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent } from '../utils/tracking.js';
import { identifyPostHog } from '../utils/posthogLazy.js';

// Simple SHA-256 hash function for user identification
const sha256 = async (str) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const trackUserIdentification = async (userId, userProperties = {}) => {
  // Hash the user ID for privacy
  const hashedUserId = await sha256(userId);
  
  const eventData = {
    user_id_hash: hashedUserId,
    user_properties: userProperties,
    ...getEnvironmentData()
  };

  // Track for Vercel Analytics
  track('user_identification', eventData);
  
  // Track for TikTok
  const tiktokEvent = {
    contents: [
      {
        content_name: 'user_identification',
        content_type: 'product',
        content_id: hashedUserId
      }
    ]
  };
  trackTikTokEvent('ViewContent', tiktokEvent);

  // PostHog proper user identification (library loads lazily, never blocks)
  if (typeof window !== 'undefined') {
    void identifyPostHog(hashedUserId, userProperties);
  }
}; 